import React from 'react';
import {
  Box,
  Typography
} from '@mui/material';
import AccessibilityTab from './AccessibilityTab';

/**
 * Compliance component - Main accessibility view
 */
const Compliance = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ mb: 3, color: '#1D4434' }}>
        Accessibility
      </Typography>

      <AccessibilityTab />
    </Box>
  );
};

export default Compliance;

